import { ProductDto } from 'common/api/autogenerated/client-area';
import { SubscriptionTransactionDto } from 'common/api/autogenerated/client-area/models/SubscriptionTransactionDto';

import { EarnSubscription } from '../list/components/Subscriptions/types';
import { EarnSubscriptionFilters } from './types';

export const initialState: {
  products: ProductDto[];
  subscriptions: EarnSubscription[];
  subscriptionsFilters: EarnSubscriptionFilters;
  history: EarnSubscription[];
  transactions: SubscriptionTransactionDto[];
  loading: {
    products: boolean;
    productsInitial: boolean;

    subscriptions: boolean;
    subscriptionsInitial: boolean;

    history: boolean;
    historyInitial: boolean;

    transactions: boolean;
    transactionsInitial: boolean;
  };
} = {
  products: [],
  subscriptions: [],
  subscriptionsFilters: {
    productType: null,
    order: 'asc',
    sortBy: 'createdOn',
  },
  history: [],
  transactions: [],
  loading: {
    products: true,
    productsInitial: true,

    subscriptions: false,
    subscriptionsInitial: true,

    history: false,
    historyInitial: true,

    transactions: true,
    transactionsInitial: true,
  },
};
